import { render, staticRenderFns } from "./PieWidgetType.vue?vue&type=template&id=3b5623e8&"
import script from "./PieWidgetType.vue?vue&type=script&lang=js&"
export * from "./PieWidgetType.vue?vue&type=script&lang=js&"
import style0 from "./PieWidgetType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports